import type { PlatformView } from '../core/types';
import { usePlatform } from './usePlatform';

export function useShouldRender(view: PlatformView = 'all'): boolean {
  const platform = usePlatform();
  if (view === 'all') return true;
  return view === platform;
}
